import type React from "react";

export interface RangeInputProps {
  id?: string;
  label: string;
  min: number;
  max: number;
  step: number;
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

export function RangeInput({ id, label, min, max, step, value, onChange, disabled }: RangeInputProps): React.ReactNode {
  return (
    <input
      className="w-full cursor-pointer appearance-none bg-transparent focus:outline-hidden disabled:pointer-events-none disabled:opacity-50 [&::-moz-range-thumb]:size-icon-inline [&::-moz-range-thumb]:appearance-none [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:border-(length:--space-xs) [&::-moz-range-thumb]:border-border-brand [&::-moz-range-thumb]:bg-background-default [&::-moz-range-thumb]:transition-all [&::-moz-range-thumb]:ease-in-out [&::-moz-range-track]:h-space-sm [&::-moz-range-track]:w-full [&::-moz-range-track]:rounded-full [&::-moz-range-track]:bg-background-tertiary [&::-webkit-slider-runnable-track]:h-space-sm [&::-webkit-slider-runnable-track]:w-full [&::-webkit-slider-runnable-track]:rounded-full [&::-webkit-slider-runnable-track]:bg-background-secondary [&::-webkit-slider-thumb]:-mt-space-xs [&::-webkit-slider-thumb]:size-icon-inline [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-background-brand [&::-webkit-slider-thumb]:shadow-raised [&::-webkit-slider-thumb]:shadow-background-brand [&::-webkit-slider-thumb]:transition-all [&::-webkit-slider-thumb]:ease-in-out"
      id={id ?? "range-input"}
      aria-label={label}
      type="range"
      value={value}
      min={min}
      max={max}
      step={step}
      onChange={(event) => onChange(Number(event.target.value))}
      disabled={disabled}
    />
  );
}
